module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_3.5ead90a9.jpeg";